<template>
  <span>
    {{ formatZipCode() }}
  </span>
</template>

<script>
export default {
  props: {
    zipCode: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    formatZipCode() {
      const cleaned = this.zipCode.replace(/\D/g, '');
      const match = cleaned.match(/^(\d{5})(\d{3})$/);
      if (match) {
        return `${match[1]}-${match[2]}`;
      }
      return this.zipCode;
    },
  },
};
</script>
